import React, { FC } from 'react';
import { SideSheet, SideSheetClose, SideSheetHeader, SideSheetSubHeader } from '@bechtel/gds';
import { WeldClaimProps } from './types';
import { t } from '@lingui/macro';
import { ClaimReclaimWeld } from '../claim-reclaim-weld';
import { WeldSubHeader } from '~/components/molecules';

export const WeldClaim: FC<WeldClaimProps> = ({ isClaimAndApprove, weld, close, isReclaim, refetchQueries }) => {
  return (
    <SideSheet visible onDismiss={close} data-testid="claim-weld-sidesheet">
      <SideSheetHeader title={isReclaim ? t`Reclaim Weld` : t`Claim Weld`}>
        <SideSheetClose onClick={close}></SideSheetClose>
      </SideSheetHeader>
      <SideSheetSubHeader>
        <WeldSubHeader
          tag={weld?.tag}
          pipeMaterial={weld?.pipeMaterial ? weld.pipeMaterial : ''}
          pipeDiameter={weld?.pipeDiameter ? weld.pipeDiameter : 0}
        />
      </SideSheetSubHeader>
      <ClaimReclaimWeld
        weldCommodity={weld}
        isReclaim={isReclaim}
        isClaimAndApprove={isClaimAndApprove}
        close={close}
        refetchQueries={refetchQueries}
      />
    </SideSheet>
  );
};
